module.exports = __webpack_public_path__ + "images/temp3f6b332fb15235a86d428479c9ede60d1.png";